<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1400"
    @keydown.esc="dialog = false"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" icon>
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog">Close</v-btn>
      </v-card-actions>
      <v-card-title>
        {{ propMember.email || propMember.phoneNumber }}
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-switch
              label="Enabled"
              v-model="memberEnabled"
              @change="changeMemberEnabledStatus"
            ></v-switch>
          </v-col>
        </v-row>

        <v-row justify="space-around">
          <!-- <v-col> -->
          <v-checkbox
            v-for="group in allAvailableMemberGroups"
            :key="group.groupName"
            v-model="$store.state.members.selectedGroups"
            :label="group.groupName"
            :value="group.groupName"
            @change="updateMemberGroupMembership(group.groupName)"
          ></v-checkbox>
          <!-- </v-col> -->
        </v-row>

        <v-row v-if="type === 'partners'">
          <v-col>
            <v-text-field
              label="New Password"
              v-model="newPassword"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-btn @click="updateMemberPassword" :disabled="!newPassword">
              Set new password
            </v-btn>
          </v-col>
        </v-row>

        <v-divider />

        <h2 class="my-5">Tenants</h2>
        <div>
          <v-row>
            <v-col>
              <v-data-table
                v-model="selected"
                :single-select="true"
                show-select
                :loading="$store.state.tenants.loading"
                :headers="tenantHeaders"
                :items="tenantList"
                :items-per-page="5"
              >
              </v-data-table>
            </v-col>
          </v-row>
        </div>

        <v-divider />

        <h2 class="my-5">Auth Events</h2>
        <div>
          <v-row>
            <v-col>
              <v-data-table
                :loading="$store.state.members.loading"
                :headers="headers"
                :items="$store.state.members.selectedAuthEvents"
                :items-per-page="5"
              >
              </v-data-table>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogMember',

  props: {
    propMember: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },

  data: () => ({
    dialog: false,
    memberEnabled: null,
    newPassword: null,
    selected: [],
    prepearingTenants: true,
    headers: [
      { text: 'Event ID', value: 'eventId' },
      { text: 'Status', value: 'eventType' },
      { text: 'Event Date', value: 'creationDate' },
      { text: 'Status', value: 'eventResponse' },
      { text: 'Risk Decision', value: 'eventRisk.riskDecision' },
      { text: 'Risk Level', value: 'eventRisk.riskLevel' },
      { text: 'Challenge Type', value: 'challengeResponses[0].challengeName' },
      {
        text: 'Challenge Status',
        value: 'challengeResponses[0].challengeResponse'
      },
      { text: 'IpAddress', value: 'eventContextData.ipAddress' },
      { text: 'City', value: 'eventContextData.city' },
      { text: 'Country', value: 'eventContextData.country' }
    ],
    tenantHeaders: [
      { text: 'Tenant ID', value: 'id' },
      { text: 'Tenant name', value: 'name' }
    ]
  }),

  mounted() {
    this.memberEnabled = this.propMember.enabled;
    this.$store.dispatch('members/resetSelectedGroups');
    this.$store.dispatch('members/resetSelectedAuthEvents');
  },

  methods: {
    closeDialog() {
      this.dialog = false;
    },

    changeMemberEnabledStatus() {
      console.log('changeMemberEnabledStatus triggered');
      const newStatus = this.memberEnabled ? 'enable' : 'disable';
      this.$store.dispatch('members/changeEnabledStatus', {
        type: this.type,
        newStatus,
        username: this.propMember.username
      });
    },

    updateMemberPassword() {
      if (this.newPassword) {
        this.$store.dispatch('members/updatePassword', {
          type: this.type,
          newPassword: this.newPassword,
          username: this.propMember.username
        });
      } else {
        console.log('Please enter a new password before trying to change it');
      }
    },

    getCurrentMemberGroups() {
      this.$store.dispatch('members/getCurrentGroups', {
        type: this.type,
        username: this.propMember.username
      });
    },

    addMemberToGroup(group) {
      this.$store.dispatch('members/addToGroup', {
        type: this.type,
        username: this.propMember.username,
        group
      });
    },

    removeMemberFromGroup(group) {
      this.$store.dispatch('members/removeFromGroup', {
        type: this.type,
        username: this.propMember.username,
        group
      });
    },

    updateMemberGroupMembership(groupName) {
      if (this.$store.state.members.selectedGroups.includes(groupName)) {
        this.addMemberToGroup(groupName);
      } else {
        this.removeMemberFromGroup(groupName);
      }
    },

    getAuthEvents() {
      this.$store.dispatch('members/getAuthEvents', {
        type: this.type,
        username: this.propMember.username
      });
    }
  },

  computed: {
    tenantList() {
      return this.$store.state.tenants.items.reduce(
        (acc, tenant) => [
          ...acc,
          {
            id: Object.keys(tenant)[0],
            name: Object.values(tenant)[0]
          }
        ],
        []
      );
    },

    allAvailableMemberGroups() {
      const formattedType = `${this.type
        .charAt(0)
        .toUpperCase()}${this.type.slice(1).toLowerCase()}`;
      return this.$store.state.members[`allAvailable${formattedType}Groups`];
    }
  },

  watch: {
    dialog(newVal, oldVal) {
      if (newVal) {
        this.getAuthEvents();
        this.$store.dispatch('members/getAllAvailableByGroupType', this.type);
        this.getCurrentMemberGroups();
        this.$store
          .dispatch('tenants/getUsersTenantsList', this.propMember.username)
          .then(usersTenants => {
            this.selected = [...new Set(usersTenants)].reduce(
              (acc, tenant) => [
                ...acc,
                {
                  id: tenant
                }
              ],
              []
            );
          });
      }
    },
    async selected(newVal, oldVal) {
      const idsChanged =
        JSON.stringify(newVal.map(tenant => tenant.id)) !==
        JSON.stringify(oldVal.map(tenant => tenant.id));
      if (!this.prepearingTenants && idsChanged && oldVal && oldVal.length)
        await this.$store.dispatch('tenants/remove', {
          userId: this.propMember.username,
          tenants: oldVal.reduce((acc, tenant) => [...acc, tenant.id], [])
        });
      if (!this.prepearingTenants && idsChanged && newVal && newVal.length)
        await this.$store.dispatch('tenants/add', {
          userId: this.propMember.username,
          tenantId: newVal[0].id
        });
      if (this.prepearingTenants) this.prepearingTenants = false;
    }
  }
};
</script>
